import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import { unpack, type } from '../../utils/index.js';
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import hsl2rgb from './hsl2rgb.js';
import rgb2hsl from './rgb2hsl.js';
Color.prototype.hsl = function () {
  return rgb2hsl(this._rgb);
};
var hsl = function hsl() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['hsl']));
};
chroma.hsl = hsl;
input.format.hsl = hsl2rgb;
input.autodetect.push({
  p: 2,
  test: function test() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args = unpack(args, 'hsl');
    if (type(args) === 'array' && args.length === 3) {
      return 'hsl';
    }
  }
});
export { hsl };